import { useDispatch } from 'react-redux';
import { useOnComponentMount } from '../../../../../hooks/use-on-component-mount';
import { LogService } from '../../../../../services/log-service';
import { sellerProvidersUpdated } from '../../../../../store/seller/seller.actions';
import { normalizeWalletData } from '../../../../../wallet/utilities/api';

const useWalletNormalization = () => {
  const dispatch = useDispatch();

  useOnComponentMount(() => {
    (async () => {
      try {
        const result = await normalizeWalletData();
        if (result.wasNormalized) {
          dispatch(sellerProvidersUpdated());
        }
      } catch (e) {
        LogService.logError(new Error('Error occurred while normalizing wallet data', { cause: e }));
      }
    })();
  });
};

export default useWalletNormalization;
